import React from 'react';
import { FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FsProps } from 'motion-components';

const gqlGetValues = gql`
  query getValues($where: String, $offset: Int, $limit: Int, $order: String) {
    getWeighingNotes(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: notes
        description: notes
      }
      recordCount
    }
  }
`;

export const deliveriesWeighingNotesWhere = JSON.stringify({ useInDeliveries: 1, isNotActive: 0 });

export const useGetWeighingNotesAsOptionsQuery = () => {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'cache-first' });
};

interface LcFsProps extends FsProps {
  size?: 'sm' | 'lg';
}

export const FieldSelectWeighingNotes = ({
  label = 'Κατηγορία Διακίνησης',
  name = 'transCatGuid',
  defaultValues = {},
  size = 'sm',
  where = undefined,
  ...rest
}: LcFsProps) => {
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      where={where}
      hook={useGetWeighingNotesAsOptionsQuery}
      height={size === 'lg' ? 32 : '22'}
    />
  );
};

